import styled from 'styled-components';
import { Modal } from 'react-bootstrap';
import { FlexBox } from '../common/FlexBox';
import CustomText from '../common/CustomText';
import CustomButton from '../common/CustomButton';
import CustomInput from 'components/common/CustomInput';
import CustomTextArea from 'components/common/CustomTextarea';
import { useMedia } from 'react-use';
import { useState } from 'react';
import axios from 'axios';
import { toBase64 } from 'hooks/Base64';
import { createEvent } from 'api/api';
import { toHex, Data, Constr, fromHex, utf8ToHex } from 'lucid-cardano';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { UPLOAD_ICON } from 'constants/image.constants';
import CustomImage from 'components/common/CustomImage';
const StyledModal = styled(Modal)`
  .modal-dialog{
    margin: auto;
    max-width: 1351px;
    width: 100%;
    
    background: transparent;
    border-radius: 16px;
    
    @media screen and (max-width: 550px) {
      max-width: 100%;
    }
  }
  .modal-header{
    border-bottom: none;
    align-items: start;
    &.btn-close{
        font-size: 40px !important;
    }

  }
  .connect-success-content {
    background: white;
    border-radius: 3px;
    width: 100%;
    overflow: hidden;
    border: none;
    
    @media screen and (max-width: 550px) {
    }
  }
`;

const ModalBody = styled(Modal.Body)`
    padding: 18px 47px 28px 28px; 
    &.modal-body{
    }
`


const CustomFile = styled.label`
  margin-top: 8px;
  height: 120px;
  width: 100%;
  border-radius: 3px;
  padding: 14px 0;
  border: 2px solid black;
  cursor: pointer;
  align-items: center;
  background: white;
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-family: Open Sans;
  color: #9E9E9E;
  font-style: normal;
  font-weight: 600;
  
  display: flex;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease-in;
  
  span{
    padding: 0 20px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
  input {
    display: none;
  }
  &:hover {
    background: #eeeeee;
    color: #000000;
  }
  @media screen and (max-width: 1100px) {
    font-size: 24px;
    line-height: 41px;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 43px;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.05em;
  }
`;

const CustomDatePicker = styled(DatePicker)`
    color: var(--greyscale-500, #9E9E9E);
    font-family: Open Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 8px 10px;
    border-radius: 3px;
    border: 2px solid black;
    @media screen and (max-width: 768px) {
        width: 100%;
    }
`

interface Props {
    show: boolean;
    onClose: () => void;
    setShowSuccessModal?: any;
    eventInputData?: any;
    setEventInputData?: any
    getEventsData: any;
}
const CreateEventModal = ({ show, onClose, setShowSuccessModal, setEventInputData, eventInputData, getEventsData }: Props) => {
    // const [clubData, setEventInputData] = useState<ClubType>({
    //     id: '',
    //     event_name: '',
    //     description: '',
    //     image: '',
    //     website: '',
    //     instagram: '',
    //     twitter: '',
    //     discord: '',
    //     location: '',
    // }
    // )
    const isMobile = useMedia('(max-width: 550px)');
    const uploadFile = async (file: Object, choice: number) => {
        // @ts-ignore
        let file_base64: string = await toBase64(file);
        // @ts-ignore
        const file_base64_array: string[] = file_base64.split('base64,');
        //console.log(file_base64_array[1]);
        const send_json = JSON.stringify({
            // @ts-ignore
            name: file.name,
            base64: file_base64_array[1]
        });

        axios
            .post('https://g8uv4l3j8i.execute-api.eu-west-2.amazonaws.com/default/uploadImage', send_json)
            .then(function (res) {
                if (res) {
                    setEventInputData((prev) => ({
                        ...prev,
                        image: res.data.base
                    }));
                }
            })
            .catch(function (err) {
                console.log(err);
            });
    };

    const createNewEvent = async () => {
        try {
            const responseStatus: number = await createEvent(eventInputData);
            if (responseStatus === 200) {
                getEventsData()
                onClose()
                setShowSuccessModal(true)
            }
        } catch (err) {
            console.log("createNewEvent err", err)
        }
    }
    return (
        <StyledModal show={show} onHide={onClose} centered contentClassName="connect-success-content">
            <Modal.Header closeButton>
            </Modal.Header>
            <ModalBody>
                <CustomText
                    fontFamily='Inconsolata'
                    fontSize='67px'
                    fontWeight='700'
                    text="Create New Event"
                    lineHeight='100%'
                    mdFontSize='21px'
                />
                <CustomText
                    text={`Event Details`}
                    marginTop='6px'
                    fontSize='28px'
                    fontWeight='700'
                    mdFontSize='16px'
                    color='#767676'
                />
                <FlexBox
                    marginTop='69px'
                    mdMarginTop='24px'
                    justifyContent='start'
                    direction='column'
                >
                    <FlexBox maxWidth='557px' direction='column'>
                        <CustomText
                            text={`<strong>*</strong>Event name:`}
                            fontSize='21px'
                            fontWeight='600'
                        />
                        <CustomInput
                            marginTop='8px'
                            placeholder='Write event name here'
                            maxWidth='557px'
                            value={eventInputData.event_name}
                            maxLength={20}
                            onChange={async (e) => {
                                setEventInputData((prev) => ({
                                    ...prev,
                                    event_name: e.target.value
                                }));
                                setEventInputData((prev) => ({
                                    ...prev,
                                    id: utf8ToHex(e.target.value + Date.now())
                                }));

                            }}
                        />
                        <FlexBox
                            direction="row-reverse"
                            justifyContent='end'

                        >
                            <CustomText
                                text={`${eventInputData.event_name.length} of 20`}
                                color='#9e9e9e'
                                paddingRight='10px'
                                fontSize='16px'
                                fontWeight='400'
                            />
                        </FlexBox>
                    </FlexBox>
                    <FlexBox justifyContent='space-between' flexWrap='wrap'>
                        <FlexBox maxWidth='557px' direction='column'>
                            <CustomText
                                text={`<strong>*</strong>Description:`}
                                fontSize='21px'
                                fontWeight='600'
                            />
                            <CustomTextArea
                                marginTop='8px'
                                placeholder='Write event description here'
                                maxWidth='557px'
                                height="117px"
                                maxLength={300}
                                value={eventInputData.description}
                                onChange={(e) => {
                                    setEventInputData((prev) => ({
                                        ...prev,
                                        description: e.target.value
                                    }));
                                }}
                            />
                            <FlexBox
                                direction="row-reverse"
                                justifyContent='end'

                            >
                                <CustomText
                                    text={`${eventInputData.description.length} of 300`}
                                    color='#9e9e9e'
                                    paddingRight='10px'
                                    fontSize='16px'
                                    fontWeight='400'
                                />
                            </FlexBox>
                        </FlexBox>
                        <FlexBox maxWidth='557px' direction='column'>
                            <CustomText
                                text={`<strong>*</strong>Upload cover image:`}
                                fontSize='21px'
                                fontWeight='600'
                            />

                            <CustomFile>
                                <CustomImage
                                    image={UPLOAD_ICON}
                                    width='32px'
                                    height='32px'
                                />
                                <span>
                                    {
                                        eventInputData.image ? eventInputData.image.split("amazonaws.com/")[1] :
                                            `Upload Image`
                                    }
                                </span>
                                <input
                                    type="file"
                                    // @ts-ignore
                                    onChange={(e) => uploadFile(e.target.files[0], 0)}
                                    accept="image/*"
                                />
                            </CustomFile>

                            <FlexBox
                                direction="row-reverse"
                                justifyContent='end'

                            >
                                <CustomText
                                    text={`2 MB`}
                                    color='#9e9e9e'
                                    paddingRight='10px'
                                    fontSize='16px'
                                    fontWeight='400'
                                />
                            </FlexBox>
                        </FlexBox>
                    </FlexBox>

                    {/*** socials */}
                    <FlexBox justifyContent='space-between' flexWrap='wrap' marginTop='53px'>
                        <FlexBox maxWidth='557px' direction='column'>
                            <CustomText
                                text={`<strong>*</strong>Event Date/Time:`}
                                fontSize='21px'
                                fontWeight='600'
                            />
                            <CustomDatePicker
                                selected={eventInputData.endTimeString}
                                onChange={(d: Date) => {
                                    const today = new Date();
                                    if (d > today) {
                                        const targetDate = new Date(d);
                                        setEventInputData((prevFormData) => ({
                                            ...prevFormData,
                                            event_time: targetDate.getTime(),
                                            endTimeString: d
                                        }));

                                    }
                                }}
                                showTimeSelect
                                timeFormat="p"
                                timeIntervals={15}
                                dateFormat="Pp"
                                showTimeInput
                                placeholder="MM/DD/YYYY 5PM EST"

                            />
                        </FlexBox>

                    </FlexBox>

                    <FlexBox justifyContent='space-between' flexWrap='wrap' marginTop='16px'>
                        <FlexBox maxWidth='557px' direction='column'>
                            <CustomText
                                text={`<strong>*</strong>Location/Link`}
                                fontSize='21px'
                                fontWeight='600'
                            />
                            <CustomInput
                                marginTop='8px'
                                placeholder='Location/link to event'
                                maxWidth='557px'
                                value={eventInputData.event_location}
                                onChange={(e) => {
                                    setEventInputData((prev) => ({
                                        ...prev,
                                        event_location: e.target.value
                                    }));
                                }}
                            />

                        </FlexBox>

                    </FlexBox>

                </FlexBox>

                <FlexBox
                    marginTop='76px'
                    justifyContent='end'
                    mdDirection='row-reverse'
                    mdJustifyContent='end'
                >
                    <CustomButton
                        disabled={
                            eventInputData.event_name === "" || eventInputData.description === "" ||
                            eventInputData.location === "" || eventInputData.event_time === "" || eventInputData.image === ""
                        }
                        onClick={() => { createNewEvent() }}
                        width='407px'
                        height='65px'
                        fontSize='30px'
                        fontWeight='600'
                        smWidth='171px'
                        smHeight='42px'
                        smFontSize='16px'
                        text='Create'
                    />
                </FlexBox>
            </ModalBody>

        </StyledModal>
    )
}

export default CreateEventModal